import React, { Component } from 'react'

import SectionControls from 'components/controls/section-controls'
import TeamRoute from 'sections/team/team-route'

export default class SingleTeamPeople extends Component {
	state = {
		searchTerm: '',
		toggleState: 0,
	}

	toggleOptions = [
		{
			name: 'Grid view'
		},
		{
			name: 'List view'
		}
	]

	toggleView = _ => {
		this.setState({
			toggleState: !this.state.toggleState
		})
	}

	onSearchTermChange = searchTerm => {
		this.setState({
			searchTerm
		})
	}

	render() {
		const {
			searchTerm,
			toggleState
		} = this.state

		const {
			team
		} = this.props

		return (
			<div className={"team-people"}>
				<SectionControls 
					toggleState={toggleState} 
					toggleChangeCallback={this.toggleView} 
					searchTerm={searchTerm} 
					onSearchTermChange={this.onSearchTermChange} 
					toggleOptions={this.toggleOptions} 
				/>
				<TeamRoute 
					userIds={team.userIds}
					type={'people'}
					amAdmin={false}
					searchTerm={searchTerm}
					toggleState={toggleState}
				/>
			</div>
		)
	}
}
